<div class="visit-trip" [ngStyle]="{'margin-left': visible ? scrollPosition + 'px' : '0'}">
  <div class="trip-actions">
    <a (click)="onDeleteTrip(trip)" class="btn btn-outline btn-slim btn-auto-width"
      *ngIf="authService.hasPermission(Permissions.VisitTripDelete) && (trip.rideHealthStatus === 'NotApplicable' || trip.rideHealthStatus === '')">Delete</a>
    <a class="btn btn-secondary btn-slim btn-auto-width" *ngIf="authService.hasPermission(Permissions.VisitTripEdit)"
      (click)="onEditTrip(trip)">Edit</a>
  </div>

  <h2>{{ trip.type }} <span class="badge badge-status-{{ trip.bookingStatus.toLowerCase() }}">{{
      getTripBookingStatusDescription(trip.bookingStatus) }}</span></h2>

  <div class="trip-row">
    <div class="trip-cell">
      <label>{{ trip.type === 'Accommodation' ? 'Check-in' : 'Departure' }}</label>
      <span class="trip-date">{{ trip.departureDate | date: 'd MMM yyyy' }}</span>
      <span class="trip-time" *ngIf="trip.departureTimeMinutes !== null">{{ trip.departureDate | date: 'h:mm aaa'
        }}</span>
      <span class="trip-location">{{ trip.departureLocation }}</span>
    </div>

    <div class="trip-cell">
      <label>{{ trip.type === 'Accommodation' ? 'Check-out' : 'Arrival' }}</label>
      <span class="trip-date">{{ trip.arrivalDate | date: 'd MMM yyyy' }}</span>
      <span class="trip-time" *ngIf="trip.arrivalTimeMinutes !== null">{{ trip.arrivalDate | date: 'h:mm aaa' }}</span>
      <span class="trip-location">{{ trip.arrivalLocation }}</span>
    </div>

    <div class="trip-cell" *ngIf="trip.reference">
      <label>Reference</label>
      {{ trip.reference }}
    </div>

    <div class="trip-cell" *ngIf="trip.ticketOrConfirmationNo && trip.type !== 'Accommodation'">
      <label>Ticket No</label>
      {{ trip.ticketOrConfirmationNo }}
    </div>

    <div class="trip-cell" *ngIf="trip.bookingProvider">
      <label>Booked Through</label>
      {{ trip.bookingProvider }}
    </div>

    <div class="trip-cell" *ngIf="trip.carrier">
      <label>Carrier</label>
      {{ trip.carrier }}
    </div>

    <div class="trip-cell" *ngIf="trip.quotedAmount">
      <label>Amount Quoted</label>
      {{ renderAmount(trip.quotedAmount ) }} {{ trip.quotedCurrency }}
      <span *ngIf="trip.quotedAmountBC && trip.quotedAmountBC !== trip.quotedAmount">({{
        renderAmount(trip.quotedAmountBC)}} {{ trip.trialBaseCurrency }})</span>
    </div>

    <div class="trip-cell" *ngIf="trip.invoiceNo">
      <label>Invoice No</label>
      {{ trip.invoiceNo }}
    </div>

    <div class="trip-cell" *ngIf="trip.paymentCardUsed">
      <label>Card Used</label>
      {{ trip.paymentCardUsed}}
    </div>
  </div>

  <div class="trip-notes" *ngIf="trip.notes !== null && trip.notes !== ''">
    <label>Notes</label>
    {{ trip.notes }}
  </div>

  <div class="pdf-generating" *ngIf="trip.pdfGenerating">
    <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
    <span class="generating-text">Generating PDF, please wait...</span>
  </div>

  <ul class="attachments" *ngIf="!trip.pdfGenerating">
    <li *ngIf="trip.ticketId"><i class="icon-paperclip" aria-hidden="true"></i> <a href="{{ trip.ticketUrl }}"
        target="_blank" rel="noopener">{{ trip.ticketOriginalFilename }}</a>
    </li>
  </ul>
</div>